import { makeRequest } from 'utils/requestLogger';

export default (id, pointTag) =>
  makeRequest('post', `/api/submissions/${id}/remove-reward`, {
    tag: pointTag,
  });



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/removeSubmissionPoint.js